import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { resolveDashbordPatients } from './patients-resolvable-exports';
import {RouterModule} from "@angular/router";

@NgModule({
  imports: [
    CommonModule,
    RouterModule.forRoot([])
  ],
  declarations: []
})
export class PatientsRoutingModule { }
